import { connect } from 'react-redux'
import { ReportGroupSelectionComponent, StateProps } from './ReportGroupSelection'
import { withRouter } from 'react-router'
import { RootState } from '../../reducers/root-reducer'

interface OwnProps {
  reportGroup?: string,
  market?: string,
  additionalRoute?: string
}
const mapStateToProps = (state: RootState, ownProps: OwnProps) : StateProps => {
  return {
    reportGroups: state.report.reportGroups,
    loading: state.report.reportGroupsLoading || state.market.marketsLoading,
    selectedReportGroup: ownProps.reportGroup,
    selectedMarket: ownProps.market,
    markets: state.market.markets,
    additionalRoute: ownProps.additionalRoute ? ownProps.additionalRoute : ''
  }
}

export const ReportGroupSelectionContainer = withRouter(
  connect(mapStateToProps)(ReportGroupSelectionComponent)
)
